import {Flex, Space} from "antd";
import React, {useEffect} from "react";
import {SettingCategoryDetails} from "./SettingCategoryDetails";
import {SettingComponentDetails} from "./SettingComponentDetails";
import {SettingDetails} from "./SettingDetails";
import {SettingList} from "./list/SettingList";
import {SettingElementDetails} from "./SettingElementDetails";
import {ListControls} from "../common/ListControls";
import {SettingItemDetails} from "./SettingItemDetails";
import {DraftComponent, DraftComponentCategory, DraftElement} from "../../../../../../feature/Draft";
import {useAppSelector} from "../../../../../../feature/tools";
import {ModelsMenu} from "../../../../../../ai/components/ModelsMenu";

export const SettingContent = () => {
    const draft = useAppSelector(state => state.draftSlice.draft)
    const [data, setData] = React.useState<{
        data: any,
        type: 'category' | 'component' | 'setting' | 'element' | 'item'
    } | undefined>(undefined)
    const [expandedKeys, setExpandedKeys] = React.useState<string[]>(['setting'])
    const [allKeys, setAllKeys] = React.useState<string[]>([])
    const [category, setCategory] = React.useState<DraftComponentCategory | undefined>(undefined)
    const [component, setComponent] = React.useState<DraftComponent | undefined>(undefined)
    const [element, setElement] = React.useState<DraftElement | undefined>(undefined)

    useEffect(() => {
        const categoriesKeys = draft.setting.categories?.map(c => "category-" + c.category).flat()
        const componentsKeys = draft.setting.categories?.map(c => c.components.map(co => "category-" + c.category + "-component-" + co.id)).flat().flat()
        const elementsKeys = draft.setting.categories?.map(c => c.components.map(co => co.elements.map(e => "category-" + c.category + "-component-" + co.id + "-element-" + e.id))).flat().flat().flat()

        setAllKeys(['setting'].concat(categoriesKeys).concat(componentsKeys).concat(elementsKeys))
        if (data?.type == 'component') {
            const comp = draft.setting.categories?.filter(c => c.category == category?.category)?.map(c => c.components).flat().find(c => c.id == data.data.id)
            setData({data: comp, type: 'component'})
        }
        if (data?.type == 'category') {
            const comp = draft.setting.categories?.find(c => c.id == data.data.id && c.category == category?.category)
            setData({data: comp, type: 'category'})
        }
        if (data?.type == 'setting') {
            setData({data: draft.setting, type: 'setting'})
        }
        if (data?.type == 'element') {
            const comp = draft.setting.categories?.filter(c => c.category == category?.category).map(c => c.components).flat().find(c => c.id == component?.id)?.elements.find(e => e.id == data.data.id)
            setData({data: comp, type: 'element'})
        }
        if (data?.type == 'item') {
            const item = draft.setting.categories?.filter(c => c.category == category?.category).map(c => c.components).flat()?.find(c => c.id == component?.id)?.elements?.find(e => e.id == element?.id)?.items?.find(i => i.id == data.data.id)
            setData({data: item, type: 'item'})
        }
    }, [draft]);


    return (
        <Flex gap={10} style={{width: "100%", height: "100%"}} align={'start'} className={"draft-details"}>
            <Flex gap={10} vertical={true} style={{width: 350, minWidth: 350, height: "100%"}}>
                <ListControls
                    allKeys={allKeys}
                    expandedKeys={expandedKeys}
                    onExpandAll={(keys) => {
                        setExpandedKeys(keys)
                    }}
                    onCollapseAll={() => {
                        setExpandedKeys([])
                    }}
                />
                <SettingList
                    selectedItem={data}
                    expandedKeys={expandedKeys}
                    onItemSelected={(data, category, component, element) => {
                        setData(data)
                        setCategory(category)
                        setComponent(component)
                        setElement(element)
                    }}
                    onItemExpanded={(key) => {
                        if (expandedKeys.includes(key)) {
                            setExpandedKeys(expandedKeys.filter(k => k != key))
                        } else {
                            setExpandedKeys([...expandedKeys, key])
                        }
                    }}
                />
            </Flex>
            <Flex gap={10} vertical={true} style={{flexGrow: 1, height: "100%"}}>
                <Space style={{justifyContent: 'end'}}><ModelsMenu/></Space>
                {data?.type == 'setting' ? <SettingDetails data={data.data}/> : ''}
                {data?.type == 'category' ? <SettingCategoryDetails data={data.data} onDeleted={() => {
                    setData({data: draft.setting, type: 'setting'})
                }}/> : ''}
                {data?.type == 'component' && category ?
                    <SettingComponentDetails data={data.data} category={category}/> : ''}
                {data?.type == 'element' && category && component ?
                    <SettingElementDetails data={data.data} category={category} component={component}/> : ''}
                {data?.type == 'item' && category && component && element ?
                    <SettingItemDetails data={data.data} category={category} component={component} element={element}/> : ''}
            </Flex>
        </Flex>
    )
}
